<template>
  <el-dialog v-if="typeDialog" v-model="formVisible" :title="title" width="35%" @close="closeDialog">
    <div class="draggable-opertion">
      <h-icon icon="icon-xiayi" font-size="24" @click="arrowPreview"></h-icon>
      <h-icon icon="icon-shangyi" font-size="24" @click="arrowNext"></h-icon>
    </div>
    <div class="draggableDialog" :style="{ height: typeDialog ? '48vh' : '40vh' }">
      <Vuedraggable class="draggable-list" v-model="draggableList" @end="endData" :itemKey="activeNameIndex">
        <template #item="{ element, index }">
          <div class="draggable-content">
            <h-button class="draggable-btn" :class="{ activedraggable: element.name == activeName }"
              @click="btnClick(element, index)"><span> {{ index + 1 }}： </span> {{ element.name }}
              <div @click="delCamera(element, index)" class="cmaera_del"></div>
            </h-button>
            <i v-show="showDel" class="iconfont icon-guanbi2" @click="handleDelete(element.name)" />
          </div>
        </template>
      </Vuedraggable>
    </div>
    <template #footer>
      <h-button type="primary" @click="emitCheckList">确定</h-button>
      <h-button @click="showDel = !showDel">{{showDel? '取消删除':'删除'}}</h-button>
    </template>
  </el-dialog>
  <div>
    <div class="draggable-opertion">
      <h-icon icon="icon-xiayi" font-size="24" @click="arrowPreview"></h-icon>
      <h-icon icon="icon-shangyi" font-size="24" @click="arrowNext"></h-icon>
    </div>
    <div class="draggableDialog" :style="{ height: typeDialog ? '57vh' : '40vh' }">
      <Vuedraggable class="draggable-list-content" v-model="draggableList" @end="endData" :itemKey="activeNameIndex">
        <template #item="{ element, index }">
          <div class="draggable-content">
            <h-button class="draggable-btn" style="justify-content: flex-start" :class="[
              { activedraggable: element.name == activeName },
              'text-ellipsis',
            ]" @click="btnClick(element, index)"><span> {{ index + 1 }}： </span> {{ element.name }}
            </h-button>
            <i class="iconfont icon-guanbi2" @click="handleDelete(element.name)" />
          </div>
        </template>
      </Vuedraggable>
    </div>
  </div>
</template>
<script>
import { ElMessage } from "element-plus";
import {
  defineComponent,
  watchEffect,
  reactive,
  toRefs,
  onMounted
} from "vue";
import Vuedraggable from "vuedraggable";
export default defineComponent({
  emits: ["update:visible", "updateDraggable"],
  name: "draggableDialog",
  components: { Vuedraggable },
  props: {
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false
    },
    draggableData: {
      type: Object,
      default: () => { [] }
    },
    typeDialog: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "区域排序"
    }
  },
  setup(props, context) {
    const data = reactive({
      formVisible: false,
      showDel: false,
      draggableList: [],
      activeName: "",
      activeNameIndex: 0,
      seqList: []
    });
    watchEffect(() => {
      data.formVisible = props.visible;
      data.draggableList = props.draggableData;
    });
    onMounted(() => {
      data.draggableList.forEach((element) => {
        data.seqList.push(element.seq);
      });
    });
    const btnClick = (el, index) => {
      data.activeName = el.name;
      data.activeNameIndex = index;
    };
    // 下移
    const arrowNext = () => {
      if (data.activeName == "") {
        ElMessage.warning("请选择节点");
        return;
      }
      if (data.activeNameIndex <= 0) {
        ElMessage.warning("已到最前一项");
        return;
      } else {
        data.activeNameIndex = data.activeNameIndex - 1;
      }
      const arr = data.draggableList.splice(data.activeNameIndex, 1);
      data.draggableList.splice(data.activeNameIndex + 1, 0, arr[0]);
    };
    // 上移
    const arrowPreview = () => {
      if (data.activeName == "") {
        ElMessage.warning("请选择节点");
        return;
      }
      const arr = data.draggableList.splice(data.activeNameIndex, 1);
      data.draggableList.splice(data.activeNameIndex + 1, 0, arr[0]);
      if (data.activeNameIndex >= data.draggableList.length - 1) {
        ElMessage.warning("已到最后一项");
        return;
      } else {
        data.activeNameIndex = data.activeNameIndex + 1;
      }
    };
    // 拖动
    const endData = (evt) => {
      console.log(evt);
      data.activeName = evt.item._underlying_vm_.name;
      data.activeNameIndex = evt.newIndex;
    };
    // 删除
    const handleDelete = (val) => {
      data.draggableList = data.draggableList.filter((element) => {
        if (element.name != val) {
          return element;
        }
      }
      );
    };
    const emitCheckList = () => {
      for (let index = 0; index < data.draggableList.length; index++) {
        data.draggableList[index].seq = data.seqList[index];
      }
      context.emit("update:visible", false);
      context.emit("updateDraggable", data.draggableList);
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
      data.showDel = false;
    };
    return {
      ...toRefs(data),
      btnClick,
      arrowPreview,
      arrowNext,
      endData,
      emitCheckList,
      closeDialog,
      handleDelete
    };
  }
});
</script>
<style lang="scss" scoped>
.draggableDialog {
  height: 40vh;
  overflow: auto;

  .draggable-list {
    @include grid-col(repeat(auto-fill, 50%), (20px 20px));
    justify-items: center;
  }

  .draggable-list-content {
    @include grid-col(repeat(auto-fill), (20px 20px));
    justify-items: start;
  }

  .draggable-content {
    width: 80%;
    margin-top: 12px;
    display: flex;
    align-items: center;
    position: relative;

    .draggable-btn {
      width: 100%;
    }

    i {
      font-size: 14px;
      position: absolute;
      right: -5px;
      // color: red;
      top: -5px;
      cursor: pointer;
    }
  }

  .activedraggable {
    background-color: #388ff3;
    color: #fff;
  }
}

.draggable-opertion {
  text-align: end;
  padding-right: 24px;
}
</style>
